export const statsNumbers = {
  roundsStarted: "0",
  bettingVolume: "$0",
  biggestBet: "$0",
  biggestWin: "$0",
  players: "0",
  communities: "0",
  partners: "0",
  smartContracts: "8",
};

export const urls = {
  Twitter: "https://twitter.com/dohyoprotocol",
  Discord: "https://discord.gg/2pGqeTf8rD",
  Github: "https://github.com/dohyoprotocol",
  Dapp: "https://app.dohyo.io",
  BuyLink: "https://app.uniswap.org/#/swap?inputCurrency=0x0000",
};

export const toastTypes = {
  ERROR: "Error",
  SUCCESS: "Success",
  SORRY: "Sorry",
  RELOADING: "Reloading",
  CONFIRMING: "Confirming",
  WARNING: "Warning",
};

export const colors = {
  BLUE: "blue",
  RED: "red",
  GREEN: "green",
  YELLOW: "yellow",
  BLACK: "black",
  WHITE900: "whiteAlpha.900",
  WHITE500: "whiteAlpha.500",
  WHITE300: "whiteAlpha.300",
  WHITE100: "whiteAlpha.100",
  WHITE: "whiteAlpha",
  BLACK900: "blackAlpha.900",
  BLACK500: "blackAlpha.500",
  BLUE200: "blue.200",
  PINK: "pink",
  TEAL: "teal",
  ORANGE: "orange",
  PURPLE: "purple",
  PURPLE200: "purple.200",
  red: "red",
  red200: "red.200",
  YELLOW100: "yellow.100",
  YELLOW200: "yellow.200",
  RED200: "red.200",
  GREEN200: "green.200",
  GRAY500: "gray.500",
  GRAY300: "gray.300",
  GRAY900: "gray.900",
};

export const positions = {
  CENTER: "center",
  TOP: "top",
  AUTO: "auto",
  FIXED: "fixed",
  END: "end",
  BOTTOM: "bottom",
  RIGHT: "right",
  FLEXSTART: "flex-start",
  FLEXEND: "flex-end",
};

export const weights = { BOLD: "bold" };
